import { SET_REGION, SET_TIMEZONE } from '../state/mutations/User';
import { useMutation } from '@apollo/client/react/hooks/useMutation';

import * as Localization from 'expo-localization';


export const useRegionAndTimeZoneMutation = () => {

  const [setRegionMutation] = useMutation(
    SET_REGION, {
      fetchPolicy: 'no-cache'
    }
  );

  const [setTimeZoneMutation] = useMutation(
    SET_TIMEZONE, {
      fetchPolicy: 'no-cache'
    }
  );

  const setRegion = () => {
    const locales = Localization.getLocales();
    const region = locales[0]?.regionCode;
    if(region) {
      setRegionMutation({
        variables: {
          region}}
      );
    }
  };

  const setTimezone = () => {
    const timeZone= Localization.getCalendars()[0]?.timeZone;
    if(timeZone) {
      setTimeZoneMutation({
        variables: {
          timeZone}});
    }
  };

  const setRegionAndTimezone= () => {
    setRegion();
    setTimezone();
  };
  return {setRegion, setTimezone, setRegionAndTimezone};
};